module.exports = __webpack_public_path__ + "static/media/delete-icon-gray.1d6e90cc.svg";